import { Button, DialogActions } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { I18n } from 'aws-amplify';

export default function BookmarkDialogConfirm({
    isOpen,
    msgConfirm,
    className = '',
    saveAndCancelCallBack,
    cancelCallBack,
    closeCallBack,
}) {
    return (
        <Dialog
            open={isOpen}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className={`wrapDialog ${className}`}
        >
            <DialogContent>
                <div className="confirmPlease">{msgConfirm}</div>
            </DialogContent>
            <DialogActions className="confirm-dialog-action">
                {saveAndCancelCallBack && (
                    <Button
                        onClick={saveAndCancelCallBack}
                        variant="contained"
                        style={{backgroundColor: '#CC4733', color: 'white'}}
                        size='small'
                    >
                        {I18n.get('COMBTN002')}
                    </Button>
                )}

                {closeCallBack && (
                    <Button
                        variant="contained"
                        className="btn-light btn-hg32"
                        size='small'
                        onClick={closeCallBack}
                    >
                        {I18n.get('COMBTN007')}
                    </Button>
                )}

                {cancelCallBack && (
                    <Button
                        variant="contained"
                        className="btn-light btn-hg32"
                        size='small'
                        onClick={cancelCallBack}
                    >
                        {I18n.get('COMBTN001')}
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
}
